import CheckCircleOutlineOutlined from "@mui/icons-material/CheckCircleOutlineOutlined";
import RadioButtonUncheckedOutlined from "@mui/icons-material/RadioButtonUncheckedOutlined";
import TripOriginOutlined from "@mui/icons-material/TripOriginOutlined";
import { Box, Card, CardActionArea } from "@mui/material";

import { Button, ButtonIcon } from "~/components/design-system/index.js";

export type SoadReportFormCardProps = {
  state: "not-started" | "in-progress" | "completed" | "parked";
  title: string;
  onClick: () => void;
  testId?: string;
};

export function SoadReportFormCard({
  state,
  title,
  onClick,
  testId,
}: SoadReportFormCardProps) {
  return (
    <Card
      sx={{
        borderRadius: 2,
        border: "1px solid grey",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <CardActionArea
        onClick={onClick}
        data-testid={testId}
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          "&:hover button": {
            backgroundColor: "primary.main",
            color: "white",
          },
          "&:hover button .MuiSvgIcon-root": {
            color: "white",
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {(state === "not-started" || state === "parked") && (
            <RadioButtonUncheckedOutlined
              sx={{
                color: "grey",
                fontSize: 30,
                margin: "0 0.5rem",
              }}
            />
          )}
          {state === "in-progress" && (
            <TripOriginOutlined
              sx={{
                color: "primary.main",
                fontSize: 30,
                margin: "0 0.5rem",
              }}
            />
          )}
          {state === "completed" && (
            <CheckCircleOutlineOutlined
              sx={{
                color: "green",
                fontSize: 30,
                margin: "0 0.5rem",
              }}
            />
          )}
          <Box>{title}</Box>
        </Box>
        <Box sx={{ margin: 2 }}>
          <Button
            endIcon={ButtonIcon.arrow}
            variant="text"
            label={
              state === "completed"
                ? "View"
                : state === "in-progress"
                  ? "Review"
                  : "Start"
            }
            onClick={onClick}
          />
        </Box>
      </CardActionArea>
    </Card>
  );
}
